import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { ThemeProvider, useTheme } from "@/lib/theme";
import ComingSoon from "@/pages/ComingSoon";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const AppShell = () => {
  const { theme } = useTheme();
  const isDark = theme === "dark";
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ComingSoon />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="*" element={<ComingSoon />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        theme={isDark ? "dark" : "light"}
        toastOptions={{
          style: {
            background: isDark ? "rgba(10,10,16,0.96)" : "rgba(255,255,255,0.96)",
            border: isDark
              ? "1px solid rgba(63,182,255,0.25)"
              : "1px solid rgba(11,111,255,0.25)",
            color: isDark ? "#ffffff" : "#0A0E1A",
            borderRadius: "2px",
            backdropFilter: "blur(12px)",
          },
        }}
      />
    </div>
  );
};

function App() {
  const body = (
    <ThemeProvider>
      <AppShell />
    </ThemeProvider>
  );

  if (!RECAPTCHA_KEY) return body;

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={RECAPTCHA_KEY}
      scriptProps={{ async: true, defer: true, appendTo: "head" }}
      container={{
        parameters: {
          badge: "bottomleft",
          theme: "dark",
        },
      }}
    >
      {body}
    </GoogleReCaptchaProvider>
  );
}

export default App;
